import {gql} from "@apollo/client";

export const GET_TRANSLATIONS_PER_MODULE = gql`
query translations($languageCode: String! $module: String!) {
	translations(languageCode:$languageCode,module:$module){
		translations {
			key
			value
		}
		moduleName
		languageCode
		date
	}
}`;


export const PUT_MISSING_TRANSLATION_ITEMS = gql`
mutation PutMissingTranslationItems($translations: [MissingTranslationItemInput!]!) {
    putMissingTranslationItems(translations:$translations){
       success
       message
       errors {
           message
           code
       }
    }
}`;
